export default __webpack_public_path__ + "static/mackbook_img-0103f55767f70a2a7d2a4da26ceb0601.svg";